import { Button, Form, Input, Modal } from "antd";
import { enqueueSnackbar } from "notistack";
import { useEffect, useState } from "react";
import {
  AddSpecialEmail,
  UpdateGroupList,
  UpdateSpecialEmail,
  axiosErrorMessages,
} from "../../../../API/api";
import axios, { AxiosError } from "axios";
interface AddEditGroupType {
  isAdd: boolean;
  editData: any;
  handleClose: (data: boolean) => void;
}
const AddEditSpecialEmail: React.FC<AddEditGroupType> = ({
  isAdd,
  editData,
  handleClose,
}) => {
  const [isOpen, setIsOpen] = useState<boolean>(true);
  const handleCloseAddEditPopup = () => {
    setIsOpen(false);
    handleClose(true);
  };

  const onSaveStatusHandler = (rowData: {
    specialEmail: string;
    description: string;
  }) => {
    if (rowData.specialEmail.trim()) {
      if (isAdd) {
        AddSpecialEmail(rowData.specialEmail.trim(), rowData.description.trim())
          .then((response: any) => {
            enqueueSnackbar("Added Successfully", {
              variant: "success",
              anchorOrigin: {
                vertical: "top",
                horizontal: "right",
              },
            });
            setIsOpen(false);
            handleClose(true);
          })
          .catch((error: any) => {
            if (error.response.data.errors.specialEmail[0])
              enqueueSnackbar(error.response.data.errors.specialEmail[0], {
                variant: "error",
                anchorOrigin: {
                  vertical: "top",
                  horizontal: "right",
                },
              });
            else {
              let errorMsg;
              if (axios.isAxiosError(error)) {
                const axiosError = error as AxiosError;
                errorMsg = axiosErrorMessages(axiosError);
              } else {
                errorMsg = error.message;
              }
              enqueueSnackbar(errorMsg, {
                variant: "error",
                anchorOrigin: {
                  vertical: "top",
                  horizontal: "right",
                },
              });
            }
          });
      } else {
        if (
          editData.email !== rowData.specialEmail ||
          editData.description !== rowData.description
        ) {
          const saveData = {
            specialEmailId: editData.specialEmailId,
            specialEmail: rowData.specialEmail.trim(),
            description: rowData.description.trim(),
          };
          UpdateSpecialEmail(saveData)
            .then((response: any) => {
              enqueueSnackbar("Updated Successfully", {
                variant: "success",
                anchorOrigin: {
                  vertical: "top",
                  horizontal: "right",
                },
              });
              setIsOpen(false);
              handleClose(true);
            })
            .catch((error: any) => {
              if (error.response.data.errors.SpecialEmail[0])
                enqueueSnackbar(error.response.data.errors.SpecialEmail[0], {
                  variant: "error",
                  anchorOrigin: {
                    vertical: "top",
                    horizontal: "right",
                  },
                });
              else {
                let errorMsg;
                if (axios.isAxiosError(error)) {
                  const axiosError = error as AxiosError;
                  errorMsg = axiosErrorMessages(axiosError);
                } else {
                  errorMsg = error.message;
                }
                enqueueSnackbar(errorMsg, {
                  variant: "error",
                  anchorOrigin: {
                    vertical: "top",
                    horizontal: "right",
                  },
                });
              }
            });
        } else {
          setIsOpen(false);
          handleClose(true);
        }
      }
    } else {
      enqueueSnackbar("Enter Value", {
        variant: "error",
        anchorOrigin: {
          vertical: "top",
          horizontal: "right",
        },
      });
    }
  };

  const handleResetForm = () => {
    addSpecialEmailForm.setFieldsValue({
      specialEmail: editData.email,
      description: editData.description,
    });
  };

  const [addSpecialEmailForm] = Form.useForm();
  type FieldType = {
    description?: string;
    specialEmail?: string;
  };
  useEffect(() => {
    if (!isAdd) {
      addSpecialEmailForm.setFieldsValue({
        specialEmail: editData.email,
        description: editData.description,
      });
    }
  }, []);
  return (
    <>
      <div>
        <Modal
          footer={null}
          title="Add/Edit Special Email ID"
          open={isOpen}
          onCancel={handleCloseAddEditPopup}
          maskClosable={false}
        >
          <Form
            name="basic"
            labelCol={{ span: 8 }}
            wrapperCol={{ span: 16 }}
            style={{ maxWidth: 600 }}
            onFinish={onSaveStatusHandler}
            autoComplete="off"
            form={addSpecialEmailForm}
            onReset={handleResetForm}
          >
            <Form.Item<FieldType>
              label="Special Email ID"
              name="specialEmail"
              rules={[
                { required: true, message: "Enter Email ID" },
                { type: "email", message: "Enter a Valid Email ID" },
              ]}
            >
              <Input maxLength={50} />
            </Form.Item>

            <Form.Item<FieldType>
              label="Description"
              name="description"
              rules={[{ required: true, message: "Enter Description" }]}
            >
              <Input maxLength={50} />
            </Form.Item>
            <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
              <Button className="pm-btn" type="primary" htmlType="submit">
                Save
              </Button>
              {!isAdd && (
                <Button
                  style={{ marginLeft: 20 }}
                  className="pm-btn"
                  type="primary"
                  htmlType="reset"
                >
                  Reset
                </Button>
              )}
            </Form.Item>
          </Form>
        </Modal>
      </div>
    </>
  );
};

export default AddEditSpecialEmail;
